/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { APPLICATION_VIEW_CORPORATE } from '@gh/builder-shared-data';
import { createRoute } from '@gh/builder-shared';
import { OfficeModulePermissionsDetailsComponent } from './components/office-module-permissions-details/office-module-permissions-details.component';
import { OfficePermissionsMasterZoneListComponent } from './components/office-permissions-master-zone-list/office-permissions-master-zone-list.component';
import { OfficeModulePermissionDetailsBusinessService } from './resources/office-module-permission-details-business.service';
import { OfficePermissionsMasterZoneListBusinessService } from './resources/office-permissions-master-zone-list-business.service';

const routes = [
  createRoute({
    component: OfficePermissionsMasterZoneListComponent,
    path: '',
    pathMatch: 'full',
    init: OfficePermissionsMasterZoneListBusinessService,
    auth: {
      applicationView: [APPLICATION_VIEW_CORPORATE],
    },
  }),
  createRoute({
    component: OfficeModulePermissionsDetailsComponent,
    path: ':masterZoneId',
    leave: true,
    auth: {
      applicationView: [APPLICATION_VIEW_CORPORATE],
    },
    init: OfficeModulePermissionDetailsBusinessService,
  }),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BuilderSetupOfficePermissionsRoutingModule {
}
